/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { SOCIAL_PLATFORMS, SOCIAL_PROVIDERS } from '@repo/config/social';
import { z } from 'zod';

export const SOCIAL_CHANNEL_STATUSES = ['active', 'disabled', 'disconnected'] as const;

export const socialChannelStatusSchema = z.enum(SOCIAL_CHANNEL_STATUSES);

export type ISocialChannelStatus = z.infer<typeof socialChannelStatusSchema>;

export const socialChannelSchema = z.object({
  id: z.number(),
  provider: z.enum(SOCIAL_PROVIDERS),
  platform: z.enum(SOCIAL_PLATFORMS),
  providerAccountId: z.string(),
  displayName: z.string(),
  handle: z.string().nullable(),
  avatarUrl: z.string().nullable(),
  status: socialChannelStatusSchema,
});

export type ISocialChannel = z.infer<typeof socialChannelSchema>;
